var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3323 7.20438C15.5508 4.44297 13.0117 2.41974 10 2.41974C7.4845 2.41974 5.29866 3.83125 4.19133 5.90545L5.85463 5.45977L6.24286 6.90866L2.04956 8.03225L0.925964 3.83895L2.37485 3.45072L2.85151 5.22961C4.20622 2.66644 6.89913 0.919739 10 0.919739C13.8455 0.919739 17.0635 3.606 17.88 7.20438H16.3323Z",
    fill: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66772 10.7956C4.44922 13.557 6.98834 15.5803 10 15.5803C12.5579 15.5803 14.7749 14.1208 15.8638 11.9891L14.1454 12.4495L13.7571 11.0006L17.9504 9.87706L19.074 14.0704L17.6251 14.4586L17.1646 12.7398C15.8152 15.3196 13.1132 17.0803 10 17.0803C6.15454 17.0803 2.93649 14.394 2.11997 10.7956H3.66772Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/Update.fa50c87a264f66045e6a8e1c6e8a7584.svg";
export { ForwardRef as ReactComponent };